'use strict';

/**
 * @private getRandomInt
 * @param {number} max - The maximum number
 * @returns {number} - A random number
 */
function getRandomInt(max) {
    return Math.floor(Math.random() * Math.floor(max));
}

/**
 * @private createImage
 * @param {string} name - The team member's name
 * @param {string} src - The src to use
 */
function createImage(name, src) {
    const img = document.createElement('img');
    img.src = src.replace('avatar-consultant.png', `/businessscan/team/avatar-${name.toLowerCase()}.png`);
    img.classList.add('d-none');
    document.body.appendChild(img);
}

/**
 * @private initUpdateAvatarAndName
 * @description
 * Loop through each member and replace the avatar
 */
function initUpdateAvatarAndName() {
    const team = ['Arjun', 'Christian', 'Frank', 'Hendrik', 'Henk', 'Jos', 'Jurjen', 'Koen', 'Mykyta', 'Sander'];

    let index = getRandomInt(team.length); // Start off at a random position
    const orgAvatarSrc = document.querySelector('.js-bscan-step-avatar').getAttribute('src');

    Array.from(team).forEach((memberName) => {
        createImage(memberName, orgAvatarSrc);
    });

    /**
     * @private updateAvatarAndName
     */
    function updateAvatarAndName() {
        if (orgAvatarSrc) {
            const name = team[index];

            Array.from(document.querySelectorAll('.js-bscan-step-avatar')).forEach((avatar) => {
                const newAvatarSrc = orgAvatarSrc.replace('avatar-consultant.png', `/businessscan/team/avatar-${name.toLowerCase()}.png`);
                avatar.setAttribute('src', newAvatarSrc);
            });

            index++;

            if (index === team.length) {
                index = 0;
            }
        }
    }

    updateAvatarAndName();

    setInterval(() => {
        updateAvatarAndName();
    }, 2000);
}

/**
 * @public initKonamiCode
 * @description
 * Stolen from https://gomakethings.com/how-to-create-a-konami-code-easter-egg-with-vanilla-js/
 */
function initKonamiCode() {
    const pattern = ['ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight', 'b', 'a'];
    let current = 0;

    const keyHandler = (event) => {
        // If the key isn't in the pattern, or isn't the current key in the pattern, reset
        if (pattern.indexOf(event.key) < 0 || event.key !== pattern[current]) {
            current = 0;
            return;
        }

        // Update how much of the pattern is complete
        current++;

        // If complete, alert and reset
        if (pattern.length === current) {
            current = 0;
            initUpdateAvatarAndName();
        }
    };

    // Listen for keydown events
    document.addEventListener('keydown', keyHandler, false);
}

export { initKonamiCode };
